import withAdminDashboard from "../../HOC/withAdminDashboard";
import SupplementaryDetail from "./SupplementaryDetail";

export default withAdminDashboard(SupplementaryDetail);
